<div class="dialog-wrap">
  <div class="loading-wrap" *ngIf="loading">
    <mat-spinner [diameter]="40" *ngIf="loading" color="primary" class="loading-spinner"></mat-spinner>
  </div>
  <div class="changelog-item" *ngIf="lastChangelog">
    <div class="changelog-item-header">
      <h2 class="changelog-version">{{lastChangelog.appVersion}}</h2>
      <p class="changelog-date">({{formatChangelogDate(lastChangelog.dateCreated)}})</p>
    </div>
    <div class="list">
      <div class="bugs-items">
        <div class="heading">
          <span class="material-symbols-outlined icon">bug_report</span>
          <h3 class="bugs-heading">{{'CHANGELOG.BUG_FIXES' | translate}}</h3>
        </div>
        <ul>
          <li *ngFor="let bug of lastChangelog[getCurrentLanguage()].bugs">
            {{bug}}
          </li>
        </ul>
      </div>
      <div class="features-items">
        <div class="heading">
          <span class="material-symbols-outlined icon"> stacks </span>
          <h3 class="features-heading">{{'CHANGELOG.NEW_FEATURES' | translate}}</h3>
        </div>
        <ul>
          <li *ngFor="let feature of lastChangelog[getCurrentLanguage()].features">
            {{feature}}
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="dialog-actions">
    <mat-checkbox (change)="toggleShowAgain()" *ngIf="!data.openedManually" [(ngModel)]="showAgain">{{ 'CHANGELOG.SHOW_AGAIN_FOR' | translate}}</mat-checkbox>
    <button mat-raised-button color="primary" (click)="closeDialog()">{{ "CHANGELOG.CLOSE_TEXT" | translate }}</button>
  </div>
</div>
